/* eslint-disable */
export default {
  all: 'Tutto',
  company: 'Azienda',
  personal: 'Personale',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
